import type { Product } from '../product/entry.js';
import type { DrawNumber } from './DrawNumber.js';

/**
 * Draw ID, used as a key identifier for a product draw
 */
export type DrawId = `${Product}_${DrawNumber}`;

/**
 * Constructs and returns a formatted drawId.
 *
 * @param product Product identifier
 * @param drawNumber Draw number identifier
 * @returns drawId type
 */
export function getDrawId(product: Product, drawNumber: DrawNumber): DrawId {
  return `${product}_${drawNumber}`;
}
